import { css } from '@emotion/react';

export const mainContainer = css`
    flex-wrap: nowrap;
    display: flex;
    justify-content: center;
    min-width: 1680px;
    overflow-x: auto;
    width: 100%;
`;
export const header = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    margin: 0px auto;

    font-size: 18px;
`;

export const mapHeader = css`
    display: flex;
    flex: 1;
    justify-content: center;
`;

export const mapHeaderItem = css`
    width: 250px;
    padding: 6px;
    border-radius: 20px;
    background-color: #1b50a0;
    color: #fff;
    text-align: center;
`;

export const categoryContainer = css``;

export const singleCategoryHeader = (isSingle) => css`
    display: ${isSingle ? 'flex' : 'none'};
    box-sizing: border-box;
    width: 100%;
    padding: 5px;
    border: 2px solid lightgray;
    text-align: center;
    justify-content: center;
    font-size: 16px;
`;

export const doubleCategoryHeader = (isDouble) => css`
    display: ${isDouble ? 'flex' : 'none'};
    box-sizing: border-box;
    width: 100%;
    text-align: center;
    font-size: 16px;
`;

export const categorySelector = (isSelected) => css`
    width: 50%;
    background-color: ${isSelected ? '#002755' : '#fff'};
    color: ${isSelected ? '#fff' : '#000'};
    border: 2px solid ${isSelected ? '#002755' : 'lightgray'};
    padding: 5px;
    cursor: pointer;
`;

export const tableContainer = css`
    box-sizing: border-box;
    // 변경?
    width: 512px;
    min-width: 512px;
    padding: 1rem;
`;

export const yearSelectorContainer = css`
    display: inline-flex;
    width: 100%;
    height: 50px;
    justify-content: space-between;
    align-items: center;
`;

export const categoryName = css`
    font-size: 13px;
    font-weight: 700;
`;

export const modalOpenButton = css`
    display: flex;
    align-items: center;
    color: #fff;
    background-color: #5bc0de;
    border-color: #46b8da;
    background-color: rgb(0, 39, 85);
    border-color: rgb(0, 39, 85);
    font-size: 10px;
    float: right;
    height: 25.5px;
    cursor: pointer;
`;

export const tableIcon = css`
    font-size: 13px;
`;

export const mapContainer = css`
    width: 1200px;
    min-width: 1200px;
    height: 850px;
    padding: 1rem;
`;

export const map = css`
    position: absolute;
    width: inherit;
    height: inherit;
    float: left;
`;
